import prop from 'ramda/src/prop'
import has from 'ramda/src/has'
import equals from 'ramda/src/equals'
import filter from 'ramda/src/filter'
import head from 'ramda/src/head'
import length from 'ramda/src/length'
import gte from 'ramda/src/gte'
import isNil from 'ramda/src/isNil'
import assoc from 'ramda/src/assoc'
import { SUBMIT_FORM_ERROR } from 'root/src/client/logic/form/actionIds'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import {
	formModuleLenses,
} from 'root/src/client/logic/form/lenses'
import reduce from 'ramda/src/reduce'
import path from 'ramda/src/path'
import is from 'ramda/src/is'

const { viewFormSubmitErrorMessages } = formModuleLenses

const commonErrorPaths = [
	['schemaErrors', 'type'],
	['message', 'code'],
	['message'],
	['error'],
	['error', 'error'],
	['error', 'message'],
	['error', 'message', 'message'],
	['message', 'message'],
]

export const lookupErrorMessage = (error, paths) => reduce((acc, curr) => (
	is(String, path(curr, error)) ? path(curr, error) : acc
), '', paths)

const getErrorMessage = (error) => {
	if (typeof error !== 'object') {
		// Unhandled error
		if (error && typeof error !== 'string') {
			console.error(error)
			return 'Something went wrong, please try again'
		}
		return error
	}

	if (Array.isArray(error)) {
		// We can display it with new line but with many errors it would look bad
		// return error.map(generateErrorMessage).join('\n')
		return getErrorMessage(error[0])
	}

	const errorFound = lookupErrorMessage(error, commonErrorPaths)

	if (errorFound) {
		return errorFound
	}

	// Same as above
	return getErrorMessage(Object.values(error)[0])
}

export default (moduleKey, submitIndex, error) => {
	let errorString = getErrorMessage(error)
	const moduleId = moduleIdFromKey(moduleKey)
	const formSubmitErrorMessages = viewFormSubmitErrorMessages(
		moduleId, moduleDescriptions,
	)
	if (gte(length(formSubmitErrorMessages), 1)) {
		const errorMessage = head(
			filter(
				errMss => equals(
					prop(prop('errorType', errMss), error),
					prop('errorCode', errMss),
				),
				formSubmitErrorMessages,
			),
		)
		if (errorMessage) {
			errorString = prop('errorMessage', errorMessage)
		}
	}
	if (has('generalErrors', error)) {
		errorString = prop('generalErrors', error)
	}
	return {
		type: SUBMIT_FORM_ERROR,
		payload: {
			moduleKey,
			submitIndex,
			error:
				has('error', error) && isNil(prop('error', error))
					? {}
					: assoc('errorString', errorString, error),
		},
	}
}
